import type { LayerKey } from '@festina-life/api'
import type { Optional } from '@festina-life/core'

import type { ComparableField } from '../../../types/diffing'
import {
  isConfigurationFunction,
  isSubTemplatedFieldValue,
  isTemplateField,
  isTemplateVersion,
} from '../../../types/templateModel'
import { isSpecialCasedSubTemplatedValueSetup } from '../../specialCasedSubTemplatedViewers/types'
import { SpecialCasedSubTemplatedFieldValueTitle } from './SpecialCasedSubTemplatedFieldValueTitle'
import { SubTemplatedFieldValueTitle } from './SubTemplatedFieldValueTitle'
import { TemplateFieldTitle } from './TemplateFieldTitle'
import { TemplateFunctionTitle } from './TemplateFunctionTitle'
import { TemplateVersionTitle } from './TemplateVersionTitle'

type Props = {
  data: Optional<ComparableField>
  layer: LayerKey
  block: string
}

export const TemplateDetailsTitleSelector = ({ data, layer, block }: Props) => {
  if (!data) {
    return null
  }

  if (isSpecialCasedSubTemplatedValueSetup(data)) {
    return (
      <SpecialCasedSubTemplatedFieldValueTitle
        data={data}
        layer={layer}
        block={block}
      />
    )
  }

  if (isConfigurationFunction(data)) {
    return <TemplateFunctionTitle data={data} layer={layer} block={block} />
  } else if (isTemplateField(data)) {
    return <TemplateFieldTitle field={data} layer={layer} block={block} />
  } else if (isTemplateVersion(data)) {
    return <TemplateVersionTitle templateVersion={data} />
  } else if (isSubTemplatedFieldValue(data)) {
    return (
      <SubTemplatedFieldValueTitle variant={data} layer={layer} block={block} />
    )
  } else {
    throw new Error('Unsupported field type.')
  }
}
